import { FileText, MessageSquare, Sparkles } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const automateFreshdeskCustomFieldsFillUpAr: TemplateAr = {
  name: 'أتمتة تعبئة حقول Freshdesk المخصصة بالذكاء الاصطناعي',
  description:
    'تعبئة حقول Freshdesk المخصصة تلقائياً أثناء المحادثات، وإنهاء الإدخال اليدوي للبيانات على فريق الدعم.',
  category: 'دعم العملاء',
  workflow: [
    { icon: MessageSquare, label: 'العميل' },
    { icon: Sparkles, label: 'الـ AI يستخرج' },
    { icon: FileText, label: 'الحقول معبّأة', final: true },
  ],
  detailDescription: {
    paragraph1:
      'خلّ حقول Freshdesk المخصصة تتعبّى وأنت تتكلم مع العميل. الـ AI يستخرج المعلومة من المحادثة، ويحدد نقاط البيانات الأساسية، ويملأ حقول التذكرة لحظياً.',
    paragraph2:
      'بيانات الحقول تلقاها مباشرة في تذاكر Freshdesk. والنظام يشتغل مع أتمتة Freshdesk وسير العمل اللي عندك أصلاً. والـ AI يتعلّم بنية حقولك ويتأقلم مع إعداداتك.',
  },
  benefits: [
    'موظفك يخلّص من الإدخال اليدوي للبيانات',
    'الحقول تتعبّى بنفس الطريقة كل مرة',
    'وقت معالجة التذكرة ينزل',
    'تقاريرك تصير أدق',
    'سجل تدقيق كامل لأغراض الامتثال',
    'يشتغل مع كل حقول Freshdesk المخصصة',
  ],
};
